module.exports = __webpack_public_path__ + "img/Beauty Treatments 4.aec36e41.jpg";